import React, { useEffect, useState } from "react";
import SchoolAdminDashboard from "../schoolAdminDashboard";
import { useParams, useHistory } from "react-router-dom";
import Popover from "@material-ui/core/Popover";
import blankProfile from "../images/blank-profile.png";
import moment from "moment";
import { formatPhoneNumber } from "../../../utils";
import SchoolStatus from "../SchoolAdminPages/SchoolStatus/SchoolStatus";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox } from "@mui/material";
import { BsCircle, BsFillCheckCircleFill } from "react-icons/bs";
import {
  getTeamAdminData,
  getTeamAdminPermissions,
  resetTeamAdminData,
} from "../../../Redux/Actions/TeamAdminActions";
import DeleteIcon from "@mui/icons-material/Delete";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RestoreIcon from "@mui/icons-material/Restore";
import { resetGroupData } from "../../../Redux/Actions/GroupActions";
import { openConfirmationPopup } from "../../../Redux/Actions/PopupActions";
import SettingsPopup from "../../../Common/SettingsPopup";
import { ContentLayoutSpinner } from "../../spinner/ContentLayoutSpinner";
import ContentLayoutDetailsHeader from "../../../Common/ContentLayoutDetailsHeader";
import { AiFillSetting } from "react-icons/ai";
import { MdModeEdit } from "react-icons/md";
import { getFromLocalStorage } from "../../../utils/webStorage";

const TeamAdminDetails = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const adminRole = getFromLocalStorage("loginRole");
  const teamAdminData = useSelector((state) => state?.TeamAdminData);
  const selectedGroupList = useSelector(
    (state) => state?.GroupsData?.selectedGroupList
  );
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );
  const loading = useSelector((state) => state?.TeamAdminData?.loading);
  const dispatch = useDispatch();
  const history = useHistory();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const { teamId } = useParams();

  useEffect(() => {
    teamId && getTeamAdminData(dispatch, { id: teamId });
    getTeamAdminPermissions(dispatch, null);
    return () => {
      resetTeamAdminData(dispatch);
      resetGroupData(dispatch);
    };
  }, []);

  const formatDate = (date) => {
    return moment(date).format("MM-DD-YYYY");
  };

  const handleDelete = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure You Want To Delete This Team Admin?",
        btnColor: "red",
        btnText: "Yes",
        id: teamId,
        type: "Team Admin Delete",
      },
    });
  };

  const handleReset = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure You Want To Reset The Password?",
        btnColor: "green",
        btnText: "Yes",
        email: teamAdminData?.teamAdminData?.email,
        type: "Reset Password",
      },
    });
  };

  const handleActivateInactivateTeamAdmin = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: `Are You Sure You Want To ${
          teamAdminData?.teamAdminData?.user?.active ? "Deactivate" : "Activate"
        } This Team Admin?`,
        btnColor: "red",
        btnText: "Yes",
        id: teamAdminData?.teamAdminData?.id,
        status: !teamAdminData?.teamAdminData?.user?.active,
        type: "Team Admin Activate / Deactivate",
      },
    });
  };

  const settingList = () => {
    let menuList = [];
    switch (true) {
      case teamAdminData?.teamAdminData?.user?.deleted === true:
        menuList = [
          {
            id: 1,
            name: "Recover Team Admin",
            icon: <RestoreIcon className="manage-section-iconss" />,
            handleSubmit:
              teamAdminData?.teamAdminData?.user?.isFirstTime === false
                ? handleActivateInactivateTeamAdmin
                : handleReset,
          },
        ];
        break;

      case teamAdminData?.teamAdminData?.user?.active === true:
        menuList = [
          {
            id: 1,
            name: "Delete Team Admin",
            icon: <DeleteIcon className="manage-section-iconss delete-icon" />,
            handleSubmit: handleDelete,
          },
          {
            id: 2,
            name: "Reset Password",
            icon: <VpnKeyIcon className="manage-section-iconss" />,
            handleSubmit: handleReset,
          },
          {
            id: 3,
            name: teamAdminData?.teamAdminData?.user?.active
              ? "Deactivate Team Admin"
              : "Activate Team Admin",
            icon: teamAdminData?.teamAdminData?.user?.active ? (
              <DoDisturbOnIcon className="manage-section-iconss" />
            ) : (
              <CheckCircleIcon className="manage-section-iconss" />
            ),
            handleSubmit: handleActivateInactivateTeamAdmin,
          },
        ];
        break;

      case teamAdminData?.teamAdminData?.user?.isFirstTime === false &&
        teamAdminData?.teamAdminData?.user?.active === false:
        menuList = [
          {
            id: 1,
            name: "Delete Team Admin",
            icon: <DeleteIcon className="manage-section-iconss delete-icon" />,
            handleSubmit: handleDelete,
          },
          {
            id: 2,
            name: "Reset Password",
            icon: <VpnKeyIcon className="manage-section-iconss" />,
            handleSubmit: handleReset,
          },
          {
            id: 3,
            name: teamAdminData?.teamAdminData?.user?.active
              ? "Deactivate Team Admin"
              : "Activate Team Admin",
            icon: teamAdminData?.teamAdminData?.user?.active ? (
              <DoDisturbOnIcon className="manage-section-iconss" />
            ) : (
              <CheckCircleIcon className="manage-section-iconss" />
            ),
            handleSubmit: handleActivateInactivateTeamAdmin,
          },
        ];
        break;

      case teamAdminData?.teamAdminData?.user?.active === false:
        menuList = [
          {
            id: 1,
            name: "Delete Team Admin",
            icon: <DeleteIcon className="manage-section-iconss delete-icon" />,
            handleSubmit: handleDelete,
          },
          {
            id: 2,
            name: "Reset Password",
            icon: <VpnKeyIcon className="manage-section-iconss" />,
            handleSubmit: handleReset,
          },
        ];
        break;
      default:
        break;
    }
    return menuList;
  };

  const headerIcons = [
    {
      id: 1,
      icon: <MdModeEdit className="header-icon" />,
      handleClick: () => history.push(`/editteamadmin/${teamId}`),
    },
    {
      id: 2,
      icon: <AiFillSetting className="header-icon" />,
      handleClick: handleClick,
    },
  ];

  return (
    <>
      <div
        className={
          isDrawerOpen
            ? "content-layout add-sectionn p-0 position-relative"
            : "toggle-content-layout add-sectionn p-0 position-relative"
        }
        // className="content-layout add-sectionn p-0 position-relative"
      >
        <SchoolAdminDashboard />
        <ContentLayoutSpinner animate={loading?.pageLoading} />
        <ContentLayoutDetailsHeader
          label="Team Admin"
          name={
            teamAdminData?.teamAdminData?.firstName ||
            teamAdminData?.teamAdminData?.lastName
              ? `${teamAdminData?.teamAdminData?.firstName || ""} ${
                  teamAdminData?.teamAdminData?.lastName || ""
                }`
              : ""
          }
          navigationLink="/teamadmin"
          iconList={adminRole === "SCHOOL ADMIN" ? headerIcons : []}
        />
        <div className="dynamic-height position-relative">
          <div>
            <div className="d-flex-align-cent pd-20 gap-20 flex-wrap light-grey-border">
              <img
                className="details-profile img-fluid"
                src={
                  teamAdminData?.teamAdminLogo
                    ? teamAdminData?.teamAdminLogo
                    : blankProfile
                }
                alt="PIC"
              />
              <div>
                <h4 className="fs-30 bold athlete-nm">
                  {teamAdminData?.teamAdminData?.firstName}{" "}
                  {teamAdminData?.teamAdminData?.lastName}
                </h4>
                <h6 className="mt-1 semi-bold fs-18">
                  {teamAdminData?.teamAdminData?.specialty}
                </h6>
              </div>
              <SchoolStatus
                status={
                  teamAdminData?.teamAdminData?.user &&
                  teamAdminData?.teamAdminData?.user.active
                }
                isDeleted={
                  teamAdminData?.teamAdminData?.user &&
                  teamAdminData?.teamAdminData?.user.deleted
                }
              />
            </div>
            <div className="container-height-dynamic">
              <div className="col-12 col-lg-6 col-md-10  w-100 plr pt-1">
                <div className="clear10"></div>
                <div className="row p-1 ">
                  <label className="fs-20 bold">Personal Information</label>
                </div>
                <div className="team-details fs-18">
                  <div className="row p-1">
                    <div className="col-12 col-lg-4 col-md-4 fmlabel">
                      <label>Date Joined</label>
                    </div>
                    <div className="col-12 col-lg-8 col-md-8">
                      <p>
                        {formatDate(teamAdminData?.teamAdminData?.createdAt)}
                      </p>
                    </div>
                  </div>
                  <div className="row p-1">
                    <div className="col-12 col-lg-4 col-md-4 fmlabel">
                      <label>Email</label>
                    </div>
                    <div className="col-12 col-lg-8 col-md-8">
                      <p>{teamAdminData?.teamAdminData?.email}</p>
                    </div>
                  </div>
                  <div className="row p-1">
                    <div className="col-12 col-lg-4 col-md-4 fmlabel">
                      <label>Contact</label>
                    </div>
                    <div className="col-12 col-lg-8 col-md-8">
                      <p>
                        {formatPhoneNumber(
                          teamAdminData?.teamAdminData?.phoneNumber
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="row p-1">
                    <div className="col-12 col-lg-4 col-md-4 fmlabel">
                      <label>Specialty</label>
                    </div>
                    <div className="col-12 col-lg-8 col-md-8">
                      <p>{teamAdminData?.teamAdminData?.specialty}</p>
                    </div>
                  </div>

                  <div className="clear10"></div>
                </div>
                {selectedGroupList?.length ? (
                  <div className="team-details fs-18">
                    <div className="row p-1">
                      <div className="col-12 col-lg-4 col-md-4 fmlabel">
                        <label>Group</label>
                      </div>
                      <div className="col-12 col-lg-8 col-md-8">
                        <div className="d-flex flex-direction-c gap-7">
                          {selectedGroupList?.map((item, index) => (
                            <p key={index}>{item?.groupName}</p>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-10 col-lg-6">
                <div className="team-details2">
                  <h6 className="team-title bold fs-18">
                    Assigned Team Admin Rights
                  </h6>
                  <div className="athlete-details  mt-1">
                    {teamAdminData?.permissionRights?.map((data, index) => (
                      <div className="admin-role" key={index}>
                        <Checkbox
                          icon={<BsCircle fontSize="20px" color="#13005A" />}
                          checkedIcon={
                            <BsFillCheckCircleFill
                              fontSize="20px"
                              color="#13005A"
                            />
                          }
                          checked={teamAdminData?.selectedPermissionRights.some(
                            (item) => item.id === data.id
                          )}
                          className="rights-check-icon opacity05"
                          disabled
                        />
                        <h6 className="mx-2">{data.displayName}</h6>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <SettingsPopup settingList={settingList()} />
            </Popover>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamAdminDetails;
